// extracted by mini-css-extract-plugin
module.exports = {"container":"OSwjshwH","buttonContainer":"v7Y97FdX","alert":"n_PiPYWo"};